import axios from 'axios';
const LoginApi = async (obj: any) => {
    const response = await axios.post(`${process.env.REACT_APP_BASE_URL}vendor/signIn`, obj);
    const result = await response.data;
    return result;
};

export default LoginApi;
